import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { BrandProfit } from "@src/components/modules/reports/brand/profit";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/profitability-by-brand",
  title: () => t`Brand Profit`,
  isBeta: true,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <BrandProfit report={report} />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/profitability-by-brand")({
  component: Page,
});
